<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Result from '@/router/views/master/address/ImportResultPage'
import McButtonBack from '@/components/McButtonBack'
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import {
  GET_ADDRESS_UPLOAD_HISTORY,
  IMPORT_GEOFENCES,
  IMPORT_CUSTOMER_GEOFENCES,
  GET_IMPORT_CUSTOMER_GEOFENCES_TEMPLATE,
} from '@/services/api/master/address'

import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Result,
    McButtonBack,
    McButton,
  },
  mixins: [Helper],
  apollo: {
    importHistory: {
      query: GET_ADDRESS_UPLOAD_HISTORY,
      variables() {
        return {
          filter: {
            model: this.isCustomerImport ? 'address-customer' : 'address',
            orderBy: [JSON.stringify({ importOn: 'desc' })],
          },
        }
      },
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (loading) return
        this.totalRows = data.importHistory.importHistory.length
        this.filterOn = data.importHistory.importHistory
        this.importHistory = data.importHistory.importHistory
      },
      error(error) {
        console.log('errors', error.graphQLErrors)
      },
    },
  },
  data() {
    return {
      importHistory: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filteredItems: [],
      file: null,
      fileProp: {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      },
      showRemovedBtn: false,
      importResponse: false,
      responseData: {
        totalFailed: null,
        totalSuccess: null,
        totalData: null,
        errorFile: null,
        fileName: null,
        fileType: null,
      },
      isDownloadingTemplate: false,
      processingDots: '.',
      processingDotsInterval: null,
    }
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),

    getLoaderLogoPath() {
      return this.getAsset('secondaryLogo', 'sidebarMinimize')
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.importHistory.length
    },

    title() {
      const type = this.$route.query.type
      return this.$t(
        type === 'customer'
          ? 'master.address.uploadCustomerAddress'
          : 'master.address.uploadCompanyAddress'
      )
    },
    isCustomerImport() {
      return this.$route.query.type === 'customer'
    },
    templateUrl() {
      return 'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/templates/Template+Import+Data+Alamat.xlsx'
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: this.$t('menuitems.masterData.list.address'),
          to: '/master/address',
        },
        {
          text: this.$t('global.action.upload'),
        },
      ]
    },
    historyUpload() {
      return [
        {
          key: 'importOn',
          label: this.$t('global.importHistory.time'),
          sortable: true,
        },
        {
          key: 'filename',
          label: this.$t('global.importHistory.file'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('global.importHistory.status'),
          sortable: true,
        },
        {
          key: 'users.fullname',
          label: this.$t('global.importHistory.uploadBy'),
          sortable: true,
        },
      ]
    },
  },
  mounted() {
    if (!this.$route.query.type || !['company', 'customer'].includes(this.$route.query.type)) {
      this.$router.replace({
        name: this.$route.name,
        query: { ...this.$route.query, type: 'company' },
      })
    }

    this.$apollo.queries.importHistory.refetch()
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async handleDownloadTemplate() {
      if (this.isCustomerImport) {
        await this.downloadCustomerTemplate()
      } else {
        this.$bvModal.show('modal-template-download')
      }
    },
    directTo() {
      window.open(this.templateUrl, '_blank')
      this.$bvModal.hide('modal-template-download')
    },
    async downloadCustomerTemplate() {
      this.isDownloadingTemplate = true
      try {
        const response = await this.$apollo.query({
          query: GET_IMPORT_CUSTOMER_GEOFENCES_TEMPLATE,
          fetchPolicy: 'no-cache',
        })

        const templateData = response.data.importCustomerGeofenceTemplate

        if (templateData.isSuccessful) {
          const base64String = templateData.importCustomerGeofencesTemplate.templateFile
          const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

          var temp = 'data:' + fileType + ';base64,' + encodeURIComponent(base64String)
          var download = document.createElement('a')
          download.href = temp
          download.download = 'Template+Import+Data+Customer+Address.xlsx'
          document.body.appendChild(download)
          download.click()
          document.body.removeChild(download)
        } else {
          this.$mcToast.error(templateData.message || this.$t('global.alert.text.templateDownloadFailed'))
        }
      } catch (error) {
        // Error downloading template
        this.$mcToast.error(this.$t('global.alert.text.templateDownloadFailed'))
      } finally {
        this.isDownloadingTemplate = false
      }
    },
    refreshData() {
      this.$apollo.queries.importHistory.refetch()
    },
    startProcessingAnimation() {
      if (this.processingDotsInterval) {
        clearInterval(this.processingDotsInterval)
      }

      this.processingDots = '.'

      this.processingDotsInterval = setInterval(() => {
        if (this.processingDots === '.') {
          this.processingDots = '..'
        } else if (this.processingDots === '..') {
          this.processingDots = '...'
        } else {
          this.processingDots = '.'
        }
      }, 500)
    },
    stopProcessingAnimation() {
      if (this.processingDotsInterval) {
        clearInterval(this.processingDotsInterval)
        this.processingDotsInterval = null
        this.processingDots = '.'
      }
    },
    async fileChangeHandler(e) {
      const files = e.target.files
      this.file = files[0]
      this.fileProp.name = files[0].name
      this.fileProp.size = (files[0].size / (1024 * 1024)).toFixed(2)

      const input = {
        filebase64: null,
        filename: files[0].name,
      }

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      input.filebase64 = (await toBase64(files[0])).split(',')[1]

      if (
        files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        (!this.isCustomerImport && files[0].type === 'text/csv')
      ) {
        if (this.fileProp.size > 10) {
          this.fileProp.message = 'license.text.tooLarge'
          this.fileProp.error = true
          return
        }
        this.fileProp.error = false
        this.showRemovedBtn = true

        // For customer import: progress goes to 90% for upload, remaining 10% for backend processing
        // For company import: keep original behavior (100% on upload completion)
        const param = this.isCustomerImport ? [15, 25, 50, 70, 90] : [15, 25, 50, 70, 90, 100]

        for (let i = 0; i < param.length; i++) {
          setTimeout(() => {
            if (this.isCustomerImport && param[i] === 90) {
              this.fileProp.sizeProgress = this.fileProp.size
              this.fileProp.progressVal = 90
              this.startProcessingAnimation()
            } else {
              this.fileProp.sizeProgress = ((this.fileProp.size * param[i]) / 100).toFixed(2)
              this.fileProp.progressVal = param[i]
            }

            if (i === param.length - 1) {
              setTimeout(() => {
                const mutation = this.isCustomerImport
                  ? IMPORT_CUSTOMER_GEOFENCES
                  : IMPORT_GEOFENCES
                this.$apollo
                  .mutate({
                    mutation: mutation,
                    variables: {
                      input: input,
                    },
                  })
                  .then((response) => {
                    const importResponse = this.isCustomerImport
                      ? response.data.importCustomerGeofences
                      : response.data.importGeofences

                    if (this.isCustomerImport) {
                      this.fileProp.progressVal = 100
                      this.stopProcessingAnimation()
                    }

                    if (importResponse.isSuccessful) {
                      this.importResponse = true

                      const importData = this.isCustomerImport
                        ? importResponse.importCustomerGeofences
                        : importResponse.importGeofences

                      this.responseData.totalData = importData.totalData
                      this.responseData.totalFailed = importData.totalFailed
                      this.responseData.totalSuccess = importData.totalSuccess
                      this.responseData.errorFile = importData.errorFile
                      this.responseData.fileName = files[0].name
                      this.responseData.fileType = files[0].type
                    } else {
                      if (
                        importResponse.message == 'Error: "Incorrect File Used."' ||
                        importResponse.message ==
                          'Error: "Error getting rows: sheet Sheet1 does not exist"'
                      ) {
                        this.fileProp.message = 'license.text.template'
                        this.fileProp.error = true
                      } else {
                        this.fileProp.error = true
                        this.$mcToast.warning(importResponse.message)
                      }
                    }
                  })
                  .catch((error) => {
                    if (this.isCustomerImport) {
                      this.fileProp.progressVal = 100
                      this.stopProcessingAnimation()
                    }

                    this.fileProp.error = true
                    this.$mcToast.error(error.message || this.$t('global.alert.text.importFailed'))
                  })
              }, 1000)
            }
          }, i * 500)
        }
      } else {
        this.fileProp.message = 'license.text.incompatible'
        this.fileProp.error = true
      }
    },
    deleteFile() {
      this.stopProcessingAnimation()
      this.importResponse = false
      this.file = null
      this.fileProp = {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <p class="mb-4">
        {{ $t('global.importData.addressPage') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            v-b-modal.modal-history-upload
            variant="secondary"
            icon="icon-outline_file-text"
            :text="$t('global.importResult.historyUpload')"
            :class="{ 'mx-2': !importResponse }"
            @click="refreshData"
          />

          <McButton
            v-if="importResponse"
            variant="primary"
            class="mx-2"
            icon="icon-outline_upload"
            :text="$t('global.importResult.uploadAgain')"
            @click="deleteFile"
          />

          <McButtonBack href="/master/address" :query="{ tab: $route.query.type }" />
        </div>
      </div>
    </div>

    <div v-if="!importResponse" class="card">
      <div class="card-body">
        <div class="mc-upload d-flex justify-content-between">
          <div class="mc-upload__file">
            <div class="mc-upload__file-wrapper">
              <div v-if="fileProp.name == null" class="mc-upload__file-area">
                <input
                  id="inputfile"
                  ref="inputfile"
                  type="file"
                  name="attachment"
                  class="mc-upload__file-area-input"
                  :accept="isCustomerImport ? '.xlsx' : '.xlsx, .csv'"
                  @change="fileChangeHandler"
                  @drop="fileChangeHandler"
                />

                <div class="mc-upload__file-area-text">
                  <i class="mc-fa icon-outline_upload"></i>
                  <p>{{ $t('global.importData.chooseFile') }}</p>
                  <p>{{ $t('global.importData.maksFile') }}</p>
                </div>
              </div>
              <div
                v-else
                :class="`mc-upload__file-result ${
                  fileProp.error ? 'mc-upload__file-result--error' : null
                }`"
              >
                <div class="mc-upload__file-result-wrapper">
                  <i class="mc-fa icon-outline_file"></i>
                  <h4 class="mc-upload__file-result-status">
                    {{ $t(fileProp.message) }}
                  </h4>
                  <div class="mc-upload__file-result-desc d-flex justify-content-between">
                    <span>{{ fileProp.name }}</span>
                    <span v-if="fileProp.error">
                      <i class="mc-fa icon-outline_trash-2" @click="deleteFile"></i>
                      <i class="mc-fa icon-fill_alert-triangle"></i>
                    </span>
                  </div>
                  <div class="mc-upload__file-result-progress">
                    <div :style="`width: ${fileProp.progressVal}%`"></div>
                  </div>
                  <span class="mc-upload__file-result-filesize">
                    <template
                      v-if="
                        isCustomerImport &&
                        fileProp.progressVal >= 90 &&
                        fileProp.progressVal <= 100 &&
                        !fileProp.error
                      "
                    >
                      {{ $t('global.importData.processing') }}{{ processingDots }}
                    </template>
                    <template v-else>
                      <span>{{ fileProp.sizeProgress }} MB / </span>{{ fileProp.size }} MB
                    </template>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mc-upload__info">
            <div class="mc-upload__info-wrapper">
              <h3 class="mc-upload__info-title">
                <i class="mc-fa icon-outline_book"></i> {{ $t('global.importData.guide') }}
              </h3>
              <ul class="mc-upload__info-list">
                <li>
                  <strong> {{ $t('global.importData.downloadTemplate') }}</strong>
                  <p>
                    {{ $t('global.importData.downloadDesc') }}
                  </p>
                  <McButton
                    variant="primary"
                    size="sm"
                    icon="icon-outline_download"
                    :text="$t('global.importData.downloadTemplate')"
                    @click="handleDownloadTemplate"
                  />
                </li>
                <li>
                  <strong> {{ $t('global.importData.copyData') }}</strong>
                  <p>
                    {{ $t('global.importData.copyDesc') }}
                  </p>
                </li>
                <li>
                  <strong> {{ $t('global.importData.upload') }}</strong>
                  <p>
                    {{ $t('global.importData.uploadDesc1') }}
                    <template v-if="isCustomerImport"> <b>.xlsx</b>. </template>
                    <template v-else>
                      <b>.csv</b>
                      {{ $t('global.object.or') }}
                      <b>.xlsx</b>.
                    </template>
                    {{ $t('global.importData.uploadDesc2') }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Result
      v-else
      :totalFailed="responseData.totalFailed"
      :totalSuccess="responseData.totalSuccess"
      :totalData="responseData.totalData"
      :errorFile="responseData.errorFile"
      :fileName="responseData.fileName"
      :fileType="responseData.fileType"
    />

    <b-modal
      id="modal-history-upload"
      class="mc-modal"
      :title="$t('global.importResult.historyUpload')"
      size="lg"
      centered
      scrollable
    >
      <div class="clearfix">
        <!-- Search -->
        <div class="float-end">
          <div class="mc-table-view">
            <div id="tickets-table_filter" class="dataTables_filter text-md-end">
              <label
                class="d-inline-flex align-items-center mc-table-view__search"
                @click="focusSearch"
              >
                <i class="mc-fa fas fa-search"></i>
                <b-form-input
                  v-model="filter"
                  type="search"
                  :placeholder="$t('global.search') + '...'"
                  class="ms-2"
                  ref="searchInput"
                />
              </label>
            </div>
          </div>
        </div>
        <!-- End search -->
      </div>

      <!-- Table -->
      <div class="table-responsive my-3 border border-1">
        <b-table
          small
          show-empty
          :fields="historyUpload"
          :items="importHistory"
          class="datatables"
          responsive="sm"
          sort-by="groupNameService"
          empty-table
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(importOn)="row">
            <p class="my-0">
              {{ momentDateShortMonth(row.value) }}
            </p>
            <p class="text-muted my-0">
              {{ momentTime(row.value) }}
            </p>
          </template>

          <template #cell(status)="data">
            <span
              v-if="
                data.item.totalFailed === 0 && (!isCustomerImport || data.item.totalSuccess > 0)
              "
              class="mc-status mc-status--green"
            >
              {{ $t('global.success') }}
            </span>
            <span v-else-if="data.item.totalSuccess === 0" class="mc-status mc-status--red">
              {{ $t('global.failed') }}
            </span>
            <span
              v-else-if="data.item.totalSuccess > 0 && data.item.totalFailed > 0"
              class="mc-status mc-status--yellow"
            >
              {{ $t('global.importResult.partialSuccess') }}
            </span>
          </template>
        </b-table>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              {{ $t('global.show') }}
              <b-form-select
                v-model="perPage"
                class="form-select form-select-sm"
                size="sm"
                :options="pageOptions"
              />
              {{ $t('global.entry') }}
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" />
            </ul>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <McButton variant="secondary" :text="$t('global.action.close')" @click="cancel()" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      id="modal-template-download"
      class="mc-modal"
      :title="$t('global.importData.downloadTemplate')"
      size="md"
      centered
      scrollable
      modal-class="mc-modal-import"
    >
      <p class="mc-modal-text">
        {{ $t('global.importData.templateDesc') }}
      </p>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <McButton variant="secondary" :text="$t('global.action.close')" @click="cancel()" />
            <McButton variant="primary" class="ms-2" text="Template & Data" @click="directTo()" />
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!--Custom Loading Overlay-->
    <div v-if="isDownloadingTemplate" class="custom-loading-overlay">
      <div v-if="!getLoaderLogoPath" class="spinner"></div>
      <img v-else :src="getLoaderLogoPath" alt="Loading..." class="loading-logo blinking" />
    </div>
  </Layout>
</template>

<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  user-select: none;

  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loading-logo {
    max-width: 150px;
    max-height: 60px;
    width: auto;
    height: auto;

    &.blinking {
      animation: blink 1.5s ease-in-out infinite;
    }
  }
}
</style>
/template>
